
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"border-radius":"50%!important"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","style":"border-radius:50%!important"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-856 -18)"}},[_c('circle',{attrs:{"cx":"6.5","cy":"6.5","r":"6.5","transform":"translate(862 24)","fill":"#f9487f"}}),_c('g',{attrs:{"transform":"translate(856 18)","fill":"none","stroke":"#f9487f"}},[_c('circle',{attrs:{"cx":"12.5","cy":"12.5","r":"12.5","stroke":"none"}}),_c('circle',{attrs:{"cx":"12.5","cy":"12.5","r":"12"}})]),_c('circle',{staticStyle:{"transform-origin":"50% 50%","transform-box":"fill-box"},attrs:{"cx":"6.5","cy":"6.5","r":"6.5","transform":"translate(862 24)","fill":"#f9487f"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","additive":"sum","from":"1 1","to":"2.2 2.2","dur":"1.4s","repeatCount":"indefinite"}}),_c('animate',{attrs:{"attributeName":"opacity","from":"1","to":"0","dur":"1.4s","repeatCount":"indefinite"}})])])])
          )
        }
      }
    